// Reads the HTTP status of an unknown error object without trusting its shape.
export function getStatusCode(error: unknown): number | undefined {
	if (!error || typeof error !== 'object' || !('statusCode' in error)) {
		return undefined;
	}
	return typeof error.statusCode === 'number' ? error.statusCode : undefined;
}
